<template>
    <div class="container">
        <div class="label">
                 <v-label>{{label}}</v-label>
        </div>
        <v-row class="ml-1 mb-0" no-gutters>
            <v-radio-group dense hide-details v-model="userGroupOption" row label="User Group Option" class="mt-1 mb-0" @change="loadUserGroups">
                 <v-radio v-for="item in userGroupTypes" :key="item.type" :label="item.groupName" :value="item.type"></v-radio>
            </v-radio-group>
        </v-row>
        <v-row class="mt-0" no-gutters dense>            
            <v-col cols="5">
                <v-text-field v-model="userGroupFilter"
                dense
                clearable
                append-outer-icon="mdi-magnify"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col>
                <v-row class="mt-0 mb-0" justify="end">
                    <v-checkbox v-model="selectAllGroupsForAdd" 
                    @change="selectAllAddingGroup" 
                    label="Select All" 
                    class="mr-4 mt-0 mb-0"></v-checkbox></v-row>
                <v-list dense class="GroupSelector">
                    <v-list-item-group
                            v-model="selectedAddGroups"
                            multiple
                            color="indigo"
                            @change="handleSelectionForAdd"
                    >
                    
                     <v-list-item
                        v-for="(item,i) in userGroupsToAdd"
                        :key="i"
                        active-class="primary--text text--accent-4"
                    >
                     <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                            <v-list-item-title v-text="item.displayName"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="primary accent-4"
                            @click.stop="toggle"
                            ></v-checkbox>
                        </v-list-item-action>
                        </template>
                    </v-list-item>
                    
                    </v-list-item-group>
                </v-list>
            </v-col>
            <v-col align="center" align-self="center" fill-height cols="1">
            
                 <v-btn fab small rounded @click="add" color="primary">>></v-btn>
                 <br/>
                 <v-btn fab small rounded @click="remove" color="primary" style="top:10px">&lt;&lt;</v-btn>
            </v-col>
                <v-col>
                    <v-row class="mt-0 mb-0" justify="end">
                        <v-checkbox v-model="selectAllGroupsForRemove" 
                        @change="selectAllRemovingGroup" 
                        label="Select All"  
                        class="mr-4 mt-0 mb-0">Select All</v-checkbox></v-row>
                     <v-list dense class="GroupSelector">
                    <v-list-item-group
                            v-model="selectedRemoveGroups"
                            multiple
                            color="indigo"
                            @change="handleSelectionForRemove"
                    >
                    
                     <v-list-item
                        v-for="(item,i) in userGroups"
                        :key="i"
                        active-class="primary--text text--accent-4"
                    >
                        <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                            <v-list-item-title v-text="item.displayName"></v-list-item-title>
                        </v-list-item-content>

                        <v-list-item-action>
                            <v-checkbox
                            :input-value="active"
                            :true-value="item"
                            color="primary accent-4"
                            @click.stop="toggle"
                            ></v-checkbox>
                        </v-list-item-action>
                        </template>
                    </v-list-item>
                    
                    </v-list-item-group>
                </v-list>
                </v-col>
        </v-row>
    </div>
</template>
<script>
import VInput from 'vuetify/lib/components/VInput/VInput.js';

const REP_GROUP_ALL="ALL_REP_USERS";

export default {
    name: 'UserGroupInput',
    props:['label','value','userGroupTypes'],
    data(){
        return{
            userGroups:[],
            selectedAddGroups:[],
            selectedRemoveGroups:[],
            userGroupFilter:"",
            userGroupOption:null,
            removedUserGroup:[],
            copyOfUserGroupsToAdd:[],
            selectAllGroupsForAdd:false,
            selectAllGroupsForRemove:false,
            dataGroups: [
                "allusergroups",
                "REPGroups",
                "Retailer",
                "Server",
                "Subvendor",
                "Supplier",
                "Team"
            ],
            dataGroupOf: {
                allusergroups: [],
                REPGroups: [],
                Retailer: [],
                Server: [],
                Subvendor: [],
                Supplier: [],
                Team: [],
            },
            retailersGroups: [],
            serversGroups: []
        };
    },
    extends: VInput,
    created() {
        if(this.value) {
           this.userGroups = this.value;
        }
        this.emitChange();
    },
    computed:{
        userGroupsToAdd(){
            // let source = this.datasource;
            let source = this.dataGroupsToAdd;
            if(this.userGroupFilter != null && this.userGroupFilter !=""){
                source = source.filter(e => e.displayName.toLowerCase().indexOf(this.userGroupFilter.toLowerCase()) != -1);
            }

            if(this.removedUserGroup.length > 0){
                this.removedUserGroup.forEach(element =>{
                    source = source.filter( e=> e!=element);
                });
            }
            return source;
        },
        datasource(){
            return this.$store.getters.getUsergroups?this.$store.getters.getUsergroups:[];
        },
        dataGroupsToAdd(){
            let dataToReturn;
            if(this.userGroupOption === 'All' || this.userGroupOption === this.dataGroups[0]){
                dataToReturn = this.dataGroupOf.allusergroups;
            }else if(this.userGroupOption === this.dataGroups[1]){
                dataToReturn =  this.dataGroupOf.REPGroups;
            }else if(this.userGroupOption === this.dataGroups[2]){
                dataToReturn =  this.dataGroupOf.Retailer;
            }else if(this.userGroupOption === this.dataGroups[3]){
                dataToReturn =  this.dataGroupOf.Server;
            }else if(this.userGroupOption === this.dataGroups[4]){
                dataToReturn =  this.dataGroupOf.Subvendor;
            }else if(this.userGroupOption === this.dataGroups[5]){
                dataToReturn =  this.dataGroupOf.Supplier;
            }else if(this.userGroupOption === this.dataGroups[6]){
                dataToReturn =  this.dataGroupOf.Team;
            }
            return dataToReturn;
        }
    },
    watch:{
        userGroupFilter(val){
            if(val!= null && val != ""){
                this.selectedAddGroups = [];
                this.selectAllGroupsForAdd = false;
            }
        },
        value(val){
           if(val && this.userGroups != val) {
            this.userGroups = val;
           }
        }
    },
    mounted(){
        this.userGroupFilter = "";
        this.selectedAddGroups = [];
        this.selectedRemoveGroups = [];
        this.userGroupOption = null;
        this.$store.dispatch("initUserGroups");
        this.loadData();
    },
    methods:{
        emitChange(){
            this.$emit('input', this.userGroups);
        },
        async loadData(){
            console.log("beginning of loadData() function");
            const userGroupsData = await this.$store.dispatch("loadUserGroupsData");
            for(const index of this.dataGroups){              
                if(index === this.dataGroups[0]){
                    this.dataGroupOf.allusergroups = userGroupsData[0]['All'];
                }else if(index === this.dataGroups[1]){
                    this.dataGroupOf.REPGroups = userGroupsData[0][index];
                }else if(index === this.dataGroups[2]){
                    this.dataGroupOf.Retailer = userGroupsData[0][index];
                    this.retailersGroups = await this.$store.dispatch("getRetailersGroups");
                }else if(index === this.dataGroups[3]){
                    this.dataGroupOf.Server = userGroupsData[0][index];
                    this.serversGroups = await this.$store.dispatch("getServersGroups");
                }else if(index === this.dataGroups[4]){
                    this.dataGroupOf.Subvendor = userGroupsData[0][index];
                }else if(index === this.dataGroups[5]){
                    this.dataGroupOf.Supplier = userGroupsData[0][index];
                }else if(index === this.dataGroups[6]){
                    this.dataGroupOf.Team = userGroupsData[0][index];
                }                  
            }
            console.log("finishing of loadData() function");
        },
        async add(){
            let allUserGroupSelected = false;
            this.copyOfUserGroupsToAdd = this.userGroupsToAdd;
            for (const index of this.selectedAddGroups){
                const element = this.copyOfUserGroupsToAdd[index];

                 if(this.userGroupOption == "Server"){
                        console.log("Fetch user group for server ",element.repGroup);
                        for(const serverKey in this.serversGroups[0]){
                            if(serverKey == element.repGroup && null != this.serversGroups[0][serverKey]){
                                this.serversGroups[0][serverKey].forEach(serverGroup =>{
                                    if(this.userGroups.findIndex(e => e.repGroup === serverGroup.repGroup) == -1){
                                        this.addToUserGroup(serverGroup);
                                    }
                                });                            
                            }
                        }
                }else if(this.userGroupOption == "Retailer"){
                        console.log("Fetch user group for retailer ",element.repGroup);                        
                        for(const retailerKey in this.retailersGroups[0]){
                            if(retailerKey == element.repGroup){
                                this.retailersGroups[0][retailerKey].forEach(retailerGroup =>{
                                    if(this.userGroups.findIndex(e => e.repGroup === retailerGroup.repGroup) == -1){
                                        this.addToUserGroup(retailerGroup);
                                    }
                                });                                
                            }
                        }
                }else{
                    if(this.userGroupOption == "REPGroups" && element.repGroup == REP_GROUP_ALL){
                            allUserGroupSelected = true;
                     }
                    if(this.userGroups.findIndex(e => e.repGroup === element.repGroup) == -1){
                            this.addToUserGroup(this.copyOfUserGroupsToAdd[index]);
                    }
                }
                this.removedUserGroup.push(element);
            }

            if(allUserGroupSelected){
                this.userGroups = [{displayName:REP_GROUP_ALL,repGroup:REP_GROUP_ALL}];
            }else{
                //remove ALL_REP_USER from userGroups
                this.userGroups = this.userGroups.filter(e => e.repGroup != REP_GROUP_ALL);
            }

            this.selectedAddGroups = [];            
            this.selectAllGroupsForAdd = false;
            this.selectAllGroupsForRemove = false;
            this.emitChange();

        },
        addToUserGroup(serveGroup){
            const tempServeGroup = {};
            tempServeGroup.displayName = serveGroup.displayName;
            tempServeGroup.repGroup = serveGroup.repGroup;
            tempServeGroup.groupType = this.userGroupOption;
            this.userGroups.push(tempServeGroup);
        },
        remove(){
            const elementToRemove = [];
            this.selectedRemoveGroups.forEach( index => {
                elementToRemove.push(this.userGroups[index]);
            });
            elementToRemove.forEach( e =>{
                this.userGroups = this.userGroups.filter(ele => ele.repGroup != e.repGroup);
                if((this.userGroupOption === 'All' && 
                (e.groupType === this.userGroupOption || 
                e.groupType === 'Team' || 
                e.groupType === 'Subvendor')) ||
                e.groupType != 'Server'){
                    this.removedUserGroup = this.removedUserGroup.filter(ele => ele.repGroup != e.repGroup);
                }
            });
            this.selectedRemoveGroups = [];
            this.selectAllGroupsForAdd = false;
            this.selectAllGroupsForRemove = false;
            this.emitChange();
        },
        loadUserGroups(){
            if(this.userGroupOption){
                    this.userGroupFilter = '';
                    this.removedUserGroup = [];
                    this.selectedAddGroups = [];
                    this.selectAllGroupsForAdd = false;
                    
            }
        },
        selectAllAddingGroup(){
            if(!this.selectAllGroupsForAdd){
                this.selectedAddGroups = [];
            }else{
                this.selectedAddGroups = [];
                for(let i =0;i<this.userGroupsToAdd.length;i++){
                    this.selectedAddGroups.push(i);
                }
            }
        },
        handleSelectionForAdd(){
            if(this.selectedAddGroups.length == this.userGroupsToAdd.length){
                this.selectAllGroupsForAdd = true;
            }else{
                this.selectAllGroupsForAdd = false;
            }
        },
        selectAllRemovingGroup(){
            if(!this.selectAllGroupsForRemove){
                this.selectedRemoveGroups = [];
            }else{
                this.selectedRemoveGroups = [];
                for(let i =0;i<this.userGroups.length;i++){
                    this.selectedRemoveGroups.push(i);
                }
            }
        },
        handleSelectionForRemove(){
            if(this.selectedRemoveGroups.length == this.userGroups.length){
                this.selectAllGroupsForRemove = true;
            }else{
                this.selectAllGroupsForRemove = false;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .label{
        background: white;
        width:180px;
        margin-top: -23px;
        padding-left: 5px;
    }
    .container{
         border: 2px lightgray solid;
    }
    .GroupSelector{
        height: 220px;
        border: 2px lightgray solid;
        overflow-y: scroll;
    }
</style>